import { render } from "./userProfileWrite.vue?vue&type=template&id=67e8510a&scoped=true"
import script from "./userProfileWrite.vue?vue&type=script&lang=js"
export * from "./userProfileWrite.vue?vue&type=script&lang=js"

import "./userProfileWrite.vue?vue&type=style&index=0&id=67e8510a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e8510a"]])

export default __exports__